import { UIView } from "@uirouter/react";
import { ErrorBoundary } from "react-error-boundary";

import { ErrorFallback } from "app/components/error-boundary-no-data/ErrorBoundaryEmptyState";

const ActivationRoot = () => {
    return (
        <ErrorBoundary FallbackComponent={(props) => <ErrorFallback {...props} />}>
            <div className="sw-layout-module-inner">
                <div
                    className="u-flex-row u-flex-column"
                    style={{ flexGrow: 1, overflowX: "hidden", width: "100%" }}
                >
                    <UIView className="sw-layout-scrollable-element sw-layout-research disable-top-padding use-sticky-css-rendering fadeIn" />
                </div>
            </div>
        </ErrorBoundary>
    );
};

export default ActivationRoot;
